import React from 'react';
interface SectionHeadingProps {
  id: string;
  title: React.ReactNode;
  eyebrow?: string;
  lead?: React.ReactNode;
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
  className?: string;
}

/** Serif heading with a gold eyebrow and a fine blue rule. */
export function SectionHeading({
  id,
  title,
  eyebrow,
  lead,
  tone = 'light',
  align = 'left',
  className = ''
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  const centered = align === 'center';
  return <div className={`${centered ? 'mx-auto text-center' : ''} max-w-3xl ${className}`} data-id="element-139" data-mp="bmpwxp3yvkso">
      {eyebrow && <p className={`label-tech flex items-center gap-3 ${centered ? 'justify-center' : ''} ${dark ? 'text-brass-light' : 'text-brass'}`} data-id="element-140" data-mp="1utuy2yrfaj6">
          <span className="h-[2px] w-6 shrink-0 bg-arc" aria-hidden data-id="element-141" data-mp="6sc5fxsfdxta" />
          {eyebrow}
          {centered && <span className="h-[2px] w-6 shrink-0 bg-arc" aria-hidden data-id="element-142" data-mp="uig0vhvgmr97" />}
        </p>}
      <h2 id={id} className={`text-balance font-brand text-[1.75rem] font-bold leading-[1.15] tracking-[-0.01em] min-[390px]:text-[1.9rem] sm:text-[2.4rem] lg:text-[2.7rem] ${eyebrow ? 'mt-3' : ''} ${dark ? 'text-white' : 'text-ink'}`} data-id="element-143" data-mp="zazkavgtwglx">
        {title}
      </h2>
      {lead && <p className={`mt-3 text-[1rem] leading-snug sm:text-[1.06rem] ${centered ? 'mx-auto max-w-2xl' : 'max-w-2xl'} ${dark ? 'text-parchment' : 'text-stone'}`} data-id="element-144" data-mp="230aeyeab4c69">{lead}</p>}
    </div>;
}